"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

/**
 * Add Event Listener to detect if the user is closing a browser tab or the browser
 */
var useDetectNavigateAway = function useDetectNavigateAway(activate) {
  var handleWindowClose = function handleWindowClose(event) {
    event.preventDefault();
    return event.returnValue = "You have unsaved data. Are you sure you want to leave ?";
  }; //Event Listener for Reload Browser actions (close browser, close tab, refresh page)


  (0, _react.useEffect)(function () {
    if (activate) {
      window.addEventListener("beforeunload", handleWindowClose); // Remove event listener on cleanup

      return function () {
        window.removeEventListener("beforeunload", handleWindowClose);
      };
    }
  }, [activate]);
};

var _default = useDetectNavigateAway;
exports["default"] = _default;